<template>
  <aside v-if="displaySidebar" class="sidebar" data-test-id="sidebar">
    <template
      v-for="({ result, component, props }, index) in mappedResults"
    >
      <component
        :is="component"
        v-if="component"
        :key="`sidebar-result-${result.title}-${index}`"
        v-bind="props"
        :data-test-id="`sidebar-result-${result.type}`"
        class="sidebar__result"
        @ad-click="onAdClick(result)"
      />
    </template>
    <ERelatedQueries
      v-if="isDesktopUp"
      :query="query"
      class="sidebar__result"
      data-test-id="sidebar-web-related-queries"
      position="sidebar"
    />
    <SatisfactionFeedback v-if="isDesktopUp" />
  </aside>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import screen from '~~/common/vue/mixins/screen';
import mapResults from '~/results/map';
import { SIDEBAR } from '~/results/position';
import SatisfactionFeedback from '~/components/satisfaction-feedback';
import ERelatedQueries from '~/components/related-queries';
import { privacyProxyMs } from '~~/common/js/constants/feature-flags';
import { satisfactionFeedbackEntity } from '~~/search/common/js/client/feature-flags';
import { trackImpressions, getTrackingProperties } from '~~/search/common/js/client/analytics/results';

export default {
  components: {
    SatisfactionFeedback,
    ERelatedQueries,
  },
  mixins: [screen],
  computed: {
    ...mapState(['sidebarResults', 'relatedSearches']),
    ...mapGetters(['hasSidebarResults']),
    ...mapGetters('unleash', ['getFeatureToggle']),
    query() {
      return this.$route.query.q?.toString();
    },
    mappedResults() {
      return mapResults(this.sidebarResults, SIDEBAR, this.getFeatureToggle);
    },
    hasRelatedSearches() {
      return this.relatedSearches && this.relatedSearches.length > 0;
    },
    isSFEExperimentEnabled() {
      return this.getFeatureToggle(satisfactionFeedbackEntity.flag)?.value ===
        satisfactionFeedbackEntity.variants.enabled;
    },
    displaySidebar() {
      if (!this.hasSidebarResults && !this.hasRelatedSearches && !this.isSFEExperimentEnabled) {
        return false;
      }
      return true;
    },
    shouldProxyTracking() {
      return this.getFeatureToggle(privacyProxyMs.flag)?.value === privacyProxyMs.enabled;
    },
    trackingOptions() {
      const trackingEntries = [];

      // eslint-disable-next-line max-len
      this.mappedResults.forEach(({ result, props }) => getTrackingProperties(result, props, trackingEntries));

      return {
        query: this.query,
        impressions: trackingEntries,
        page_position: SIDEBAR,
      };
    },
  },
  mounted() {
    if (this.hasSidebarResults) {
      // dont send an event if there are no items to track
      if (this.trackingOptions?.impressions.length > 0) {
        this.$track(trackImpressions(this.trackingOptions));
      }
    }
  },
  methods: {
    ...mapActions(['trackAdClick']),
    onAdClick({ pingSuffix }) {
      this.trackAdClick(pingSuffix, this.shouldProxyTracking);
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar__result {
  & + & {
    margin-top: $space-m;
  }
}
</style>
